import { OnDismissClickType as CssModulesOnDismissClickType, Token as CssModulesToken, TokenProps as CssModulesTokenProps } from '@sunwebgroup/uds-ui/token'
import { styled } from 'styled-components'

/**
 * @deprecated This type alias is deprecated and exists only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/token' instead.
 */
export type OnDismissClickType = CssModulesOnDismissClickType
/**
 * @deprecated This type alias is deprecated and exists only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/token' instead.
 */
export type TokenProps = CssModulesTokenProps

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/token' instead.
 */
const Token = styled(CssModulesToken)<CssModulesTokenProps>``
Object.assign(Token, { displayName: 'Token' })

export default Token
